/**
 * Wize Messaging REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageMedia } from './messageMedia';
import { MessageBody } from './messageBody';


export interface Message { 
    id?: number;
    createdAt?: string;
    threadId?: number;
    authorId?: string;
    intendedUserId?: string;
    body?: MessageBody;
    media?: MessageMedia;
    hasText?: boolean;
    hasMedia?: boolean;
    deliveryStatus?: Message.DeliveryStatusEnum;
    readStatus?: Message.ReadStatusEnum;
}
export namespace Message {
    export const DeliveryStatusEnum = {
        NEW: 'NEW',
        SENT: 'SENT',
        RETRYING: 'RETRYING',
        EXPIRED: 'EXPIRED'
    } as const;
    export type DeliveryStatusEnum = typeof DeliveryStatusEnum[keyof typeof DeliveryStatusEnum];
    export const ReadStatusEnum = {
        READ: 'READ',
        UNREAD: 'UNREAD'
    } as const;
    export type ReadStatusEnum = typeof ReadStatusEnum[keyof typeof ReadStatusEnum];
}


